import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import type { IncidentDatabase } from "../../../types";
import { keys } from "./keys";

async function getSubTopicIncidents(subTopicId: string): Promise<IncidentDatabase[]> {
  const { data, error } = await apiClient
    .from('incidents')
    .select('*')
    .eq('subject_id', subTopicId)
    .order('date', { ascending: false });

  if (error) {
    throw error;
  }

  return data ?? [];
}

export function useGetSubTopicIncidents(subTopicId: string | undefined) {
  const isEnabled = Boolean(subTopicId);

  return useQuery({
    queryKey: subTopicId ? keys.subTopicIncidents(subTopicId) : ['incidents', 'disabled'],
    queryFn: () => getSubTopicIncidents(subTopicId!),
    enabled: isEnabled,
    staleTime: _3_DAYS,
  });
}
